import React from 'react';
import { Button } from '../ui/button';
import { Eye, EyeOff } from 'lucide-react';

const HiddenDepartmentsPanel = ({
  hiddenDepartments,
  activeDepartments,
  placeholderDepartments,
  onToggleVisibility
}) => {
  const hiddenList = [...activeDepartments, ...placeholderDepartments]
    .filter(dept => hiddenDepartments[dept.id]);

  if (hiddenList.length === 0) return null;

  return (
    <div className="mb-3 p-2 bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800 rounded-lg shrink-0">
      <h4 className="text-xs font-semibold text-amber-800 dark:text-amber-200 mb-2 flex items-center gap-2">
        <EyeOff className="h-3.5 w-3.5" />
        Hidden Departments
      </h4>
      <div className="flex flex-wrap gap-1.5">
        {hiddenList.map(dept => (
          <Button
            key={dept.id}
            variant="outline"
            size="sm"
            onClick={() => onToggleVisibility(dept.id)}
            className="text-[10px] h-6 border-amber-300 dark:border-amber-700"
          >
            <Eye className="h-3 w-3 mr-1" />
            {dept.emoji} {dept.name.split(' ')[0]}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default HiddenDepartmentsPanel;